import { Injectable, Inject, LOCALE_ID } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { formatNumber, formatPercent } from "@angular/common";

@Injectable({ providedIn: "root" })
export class GridFormatService
{
    constructor(
        @Inject(LOCALE_ID) public locale: string
    ) { }

    summaryFormatter(value: any, scale: number): any
    {
        if (Utilities.IsNullOrUndefined(value) || value === "")
        {
            return "";
        }

        if (!scale)
        {
            scale = value.toString().includes(".")
                ? value.toString().split(".")[1].length
                : 0;
        }

        if (typeof value === "string")
        {
            value = value.replace("$", "").replace("%", "")
                .replace(/,/g, "");
        }

        /*
         * TODO - this is setting the minimum number of digits and keeping the
         * default maximum number of digit, which is 3.
         * see https://angular.dev/api/common/DecimalPipe#digitsinfo
         */
        return formatNumber(value, this.locale, `1.${scale}`);
    }

    nonDelineatedNumberFormatter(value: any, column: any): string
    {
        return this.numberFormatter(value, column, false).replace(/,/g, "");
    }

    numberFormatter(value: any, column: any, percent: boolean): string
    {
        if (typeof value === 'string' || value instanceof String)
        {
            if (value !== '')
            {
                value = +value.replace(/,/g, "");
            }
        }
        if (Utilities.IsNullOrUndefinedOrEmpty(value))
            return "";

        let digitsInfo: string;
        if (column)
            digitsInfo = column.DigitsInfo;
        if (Utilities.IsNullOrUndefinedOrEmpty(digitsInfo))
        {
            const intScale = value.toString().includes(".") ? value.toString().split(".")[1].length : 0;
            digitsInfo = `1.${intScale}-${intScale}`;
        }
        if (percent)
            return formatPercent(value / 100, this.locale, digitsInfo);
        if (value === '')
        {
            return value;
        }
        else
        {
            if (value < 0)
            {
                value = value * -1;
                return `(${formatNumber(value, this.locale, digitsInfo)})`;
            }
            return formatNumber(value, this.locale, digitsInfo);
        }
    }

    currencyFormatter(value: any, column: any): any
    {
        if (Utilities.IsNullOrUndefined(value) || value === "")
            return "";
        let digitsInfo: string;
        if (column)
            digitsInfo = column.DigitsInfo;
        if (Utilities.IsNullOrUndefinedOrEmpty(digitsInfo))
        {
            let intScale = value.toString().includes(".") ? value.toString().split(".")[1].length : 2;
            if (intScale < 2)
                intScale = 2;
            digitsInfo = `1.${intScale}`;
        }
        if (value < 0)
        {
            value = value * -1;
            return `($${formatNumber(value, this.locale, digitsInfo)})`;
        }
        return `$${formatNumber(value, this.locale, digitsInfo)}`;
    }
}
